import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getKeyServices } from "../../store/slices/usekeyservicesSlice";

const useKeyServices = () => {
  const dispatch = useDispatch();
  const { keyServicesData, status } = useSelector((state) => state.keyservices);
  useEffect(() => {
    if (status === "idle") {
      dispatch(getKeyServices());
    }
  }, []);

  return {
    keyServicesData,
    status,
  };
};

export default useKeyServices;
